// Shared dashboard constants

// The searchable markets: the EU 27 member states, the UK and — M4-C — Switzerland (sorted
// alphabetically). No longer EU-only, hence the neutral name (was EU_COUNTRIES).
export const MARKET_COUNTRIES = [
  'Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Cyprus', 'Czech Republic',
  'Denmark', 'Estonia', 'Finland', 'France', 'Germany', 'Greece', 'Hungary',
  'Ireland', 'Italy', 'Latvia', 'Lithuania', 'Luxembourg', 'Malta', 'Netherlands',
  'Poland', 'Portugal', 'Romania', 'Slovakia', 'Slovenia', 'Spain', 'Sweden',
  'Switzerland', 'United Kingdom'
].sort();

// P8 — Macro-category picker.
// `key` is a NEUTRAL, language-independent identifier sent to the backend, which resolves
// it directly to the market's sub-niche fan-out list. It is NOT a translation of `label`.
// `label` is what the user sees in the dropdown and on the chip.
// Adding a language later means adding label data to this one table — not rewriting logic.
export const MACRO_CATEGORIES = [
  { key: 'electronics',         label: 'Electronics' },
  { key: 'sports_outdoor',      label: 'Sports & Outdoor' },
  { key: 'food_beverages',      label: 'Food & Beverages' },
  { key: 'pet_supplies',        label: 'Pet Supplies' },
  { key: 'home_garden',         label: 'Home & Garden' },
  { key: 'auto_moto',           label: 'Auto & Motorcycle' },
  { key: 'toys_videogames',     label: 'Toys & Video Games' },
  { key: 'baby_kids',           label: 'Baby & Kids' },
  { key: 'drugstore_health',    label: 'Drugstore & Health' },
  { key: 'fashion_accessories', label: 'Fashion & Accessories' },
];

// P10: max categories per search. Each category gets its own full search run, so this
// bounds the cost of one search. MUST stay in sync with MAX_CATEGORIES_PER_SEARCH in
// backend/core/config.py, which is the authority — the server rejects anything above it.
// This copy only stops the user hitting that error.
export const MAX_CATEGORIES_PER_SEARCH = 5;

// P11: leads yielded by ONE category. There is no leads-count control any more — the total
// is simply this x the number of categories selected. Display only (the helper line under
// the categories block); the backend never reads it. MUST stay in sync with
// LEADS_PER_CATEGORY in backend/core/config.py, which is the authority.
export const LEADS_PER_CATEGORY = 10;

// Agent Check v2: the structured reasons a rejection must carry, in display order. Display
// only: backend/core/learning_events.py REJECTION_REASONS is the authority and refuses any
// other code, and refuses "other" without a note.
export const REJECTION_REASONS = [
  { code: 'wrong_category', label: 'Wrong category' },
  { code: 'not_ecommerce', label: 'Not an e-commerce' },
  { code: 'not_b2c', label: 'Not B2C / mainly B2B' },
  { code: 'manufacturer_single_brand', label: 'Manufacturer / single-brand' },
  { code: 'marketplace_aggregator', label: 'Marketplace / aggregator' },
  { code: 'too_small_limited_assortment', label: 'Too small / limited assortment' },
  { code: 'already_client', label: 'Already a client' },
  { code: 'not_relevant', label: 'Not relevant for our target' },
  { code: 'other', label: 'Other' },
];
export const REJECTION_REASON_NEEDING_NOTE = 'other';
